











import { Component, Prop, Vue } from "vue-property-decorator";
import CzPlanRow from "../cz/CzPlanRow.vue";
import CzDone from "../cz/CzDone.vue";

// One moment of "Today": its heading with the check that marks what is missing, then one row per medicine or supplement.
@Component({ components: { CzPlanRow, CzDone } })
export default class TreatmentTakeRow extends Vue {
  @Prop({ type: Object, required: true }) row!: any;
  @Prop({ type: Boolean, default: false }) busy!: boolean;
  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  get done(): boolean {
    return this.row.items.length > 0 && this.row.items.every((i: any) => i.taken);
  }

  detail(item: any): string {
    return [item.dose, item.brand].filter((x: string) => x).join(" · ");
  }

  get partial(): string {
    const taken = this.row.items.filter((i: any) => i.taken).length;
    return taken > 0 && !this.done ? this.$t("{0} of {1} taken").toString().replace("{0}", String(taken)).replace("{1}", String(this.row.items.length)) : "";
  }

  get label(): string {
    return (this.done ? this.$t("Unmark {0}").toString() : this.$t("Mark {0} as taken").toString()).replace("{0}", this.row.label);
  }
}
